'use strict';

/**
 * Contacts
 *
 * @type {{add: waApp.controllers.Contacts.index}}
 */
waApp.controllers.Staff = {
	index: function() {
		$('.employee-card').on('click', '.employee-show-bio, .employee-img', function() {
			$(this).parent().find('.employee-bio').show();
		});

		$('.employee-card').on('click', '.employee-bio-close', function() {
			$(this).closest('.employee-bio').hide();
		});
	}
};
